import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Aminities = () => {
  const { t } = useTranslation();
  const [AmenitiesData, setAmenitiesData] = useState([]);
  const [showMoreRoom, setShowMoreRoom] = useState(false);
  const [showMoreCommon, setShowMoreCommon] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/amenity_list"
        );
        setAmenitiesData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching amenities data:", error);
      }
    };

    fetchData();
  }, []);

  // Filter amenities by type
  const roomAmenities = AmenitiesData.filter(
    (item) => item.amenity_types === "Room Amenities"
  );
  const commonAmenities = AmenitiesData.filter(
    (item) => item.amenity_types === "Common Amenities"
  );

  const visibleRoomAmenities = showMoreRoom ? roomAmenities : roomAmenities.slice(0, 6);
  const visibleCommonAmenities = showMoreCommon ? commonAmenities : commonAmenities.slice(0, 6);

  return (
    <div className="container-fluid amenities-div">

      {/* COMMON AMENITIES */}
      <div className="row aminities-detail">
        <h1 style={{fontSize:"38px", display:"flex", alignItems:"center", justifyContent:"center"}}>{t("common")}</h1>
        {visibleCommonAmenities.map((item, index) => (
          <div key={index} className="col-lg-3 col-sm-6">
            <div className="service-item">
              <img
                src={`https://cyberathon.com/silverapartment/${item.icon_amenty}`}
                alt={item.title}
                loading="lazy"
                className="red-svg"
              />
              <h2 style={{fontSize:"25px", margin:"10px"}}>{item.title}</h2>
              <p>{item.description}</p>
            </div>
          </div>
        ))}

        {commonAmenities.length > 6 && (
          <div className="text-center mt-3">
            <button
              className="btn btn-outline-primary"
              onClick={() => setShowMoreCommon(!showMoreCommon)}
            >
              {showMoreCommon ? t("show_less") : t("show_more")}
            </button>
          </div>
        )}
      </div>

      {/* ROOM AMENITIES */}
      <div className="row spad1 aminities-detail">
        <h1 style={{fontSize:"35px", display:"flex", alignItems:"center", justifyContent:"center"}}>{t("room_amenities_title")}</h1>
        {visibleRoomAmenities.map((item, index) => (
          <div key={index} className="col-lg-2 col-sm-6 col-12 room-amenities">
            <div className="service-item">
              <img
                src={`https://cyberathon.com/silverapartment/${item.icon_amenty}`}
                alt={item.title}
                loading="lazy"
                className="red-svg"
              />
              <h2 style={{fontSize:"25px", margin:"10px"}}>{item.title}</h2>
              <p>{item.description}</p>
            </div>
          </div>
        ))}

        {roomAmenities.length > 6 && (
          <div className="text-center mt-3">
            <button
              className="btn btn-outline-primary"
              onClick={() => setShowMoreRoom(!showMoreRoom)}
            >
              {showMoreRoom ? t("show_less") : t("show_more")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Aminities;
